var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Buchungen heute")]},proxy:true}])},[_vm._v(" "),_c('chart-donut',{staticClass:"mb-2",attrs:{"data":_vm.data,"headline":"FooBar","colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }